import TEXTS from '../controller/TextVariables';
import { statesList } from '../model/StaticVariables';
import { useContext, useEffect, useState } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import ReactAutocomplete from 'react-autocomplete';
import { Tooltip, StandardTooltipWindow } from './Tooltip';

export default function StateSelect() {
    const { setSelectedState, usState, setStateSearch, scope } = useContext(InterfaceContext);
    const onChangeStateSelect = (val) => {
        const tehSelected = list.find((item) => {
            return item.label == val;
        });
        const sel = tehSelected?.bounds ? tehSelected : false;
        setvalue(val);
        setSelectedState(sel);
        setStateSearch(sel?.bounds);
        setFilteredList(list);
    };
    const [enabled, setEnabled] = useState(scope === 'state');
    const { label, placeholder, tooltip, disabled } = TEXTS.controls.state_select;
    const list = [...statesList];
    const [value, setvalue] = useState(usState ? usState.label : '');
    const [filtededList, setFilteredList] = useState(list);
    const [activeToolTip, setActiveToolTip] = useState(disabled);

    const forceCloseWindow = () => {
        const dropMenu = document.querySelector('#state-select > div > div');
        if (dropMenu) {
            dropMenu.style.display = 'none';
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', forceCloseWindow);
        return () => {
            window.removeEventListener('scroll', forceCloseWindow);
        };
    }, []);
    //@@##
    useEffect(() => {
        setvalue(usState ? usState.label : '');
    }, [usState]);
    useEffect(() => {
        setEnabled(scope === 'state');
        if (scope === 'state' && value === '') {
            setTimeout(() => document.querySelector('.state.field input').focus(), 500);
            setActiveToolTip(tooltip);
        } else if (scope !== 'state') {
            setvalue('');
            setActiveToolTip(disabled);
        }
    }, [scope]);
    return (
        <>
            <div id="state-select" className="state field">
                <Tooltip id={label} tooltip={activeToolTip} window={<StandardTooltipWindow id={label} text={activeToolTip} tooltipPlace={'left'} />}>
                    <label className={'icon-selectarrow' + (!enabled ? ' disabled' : '')}> {label} </label>
                    <ReactAutocomplete
                        items={filtededList}
                        inputProps={{
                            placeholder: placeholder,
                            disabled: !enabled,
                            tabIndex: 0
                        }}
                        getItemValue={(item) => item.label}
                        renderItem={(item, highlighted) => (
                            <div key={item.id} title={item.label} className={'auto-item' + (item.label === value ? ' selected' : '') + (highlighted ? ' highlight' : '')}>
                                {item.label}
                            </div>
                        )}
                        value={value}
                        onSelect={onChangeStateSelect}
                        onChange={(e) => {
                            setvalue(e.target.value);
                            let filList = list.filter((item) => {
                                return item.label.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) === 0;
                            });
                            setFilteredList(filList);
                        }}
                    />
                </Tooltip>
                {/* <DropDown {...{ selected, label, list }} focus={focus} tooltip={enabled ? tooltip : disabled} onChange={onChangeStateSelect} disabled={!enabled} /> */}
            </div>
        </>
    );
}
